import React from 'react';
import { DiffChunk as DiffChunkType } from '../../types';
import { DiffChunk } from './DiffChunk';

interface DiffReviewPanelProps {
  chunks: DiffChunkType[];
  summary: string | null;
  error?: string | null;
  onAcceptChunk: (chunkId: string) => Promise<void>;
  onRejectChunk: (chunkId: string) => void;
  onCancel: () => void;
  applyingChunkId?: string | null;
}

export function DiffReviewPanel({
  chunks,
  summary,
  error,
  onAcceptChunk,
  onRejectChunk,
  onCancel,
  applyingChunkId = null,
}: DiffReviewPanelProps) {

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b bg-gray-50">
        <div>
          <h2 className="font-semibold text-gray-900">Review Changes</h2>
          {summary && (
            <p className="text-sm text-gray-600 mt-0.5">{summary}</p>
          )}
          {error && (
            <p className="text-sm text-red-600 mt-1">{error}</p>
          )}
        </div>
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="px-3 py-1.5 text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>

      {/* Chunks list */}
      <div className="flex-1 overflow-y-auto p-4">
        {chunks.length === 0 ? (
          <div className="text-center text-gray-500 py-8">
            No changes suggested
          </div>
        ) : (
          chunks.map(chunk => (
            <DiffChunk
              key={chunk.id}
              chunk={chunk}
              onAccept={() => onAcceptChunk(chunk.id)}
              onReject={() => onRejectChunk(chunk.id)}
              applying={applyingChunkId === chunk.id}
            />
          ))
        )}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-center px-4 py-3 border-t bg-gray-50">
        <p className="text-sm text-gray-500">
          {chunks.length} {chunks.length === 1 ? 'change' : 'changes'} to review
        </p>
      </div>
    </div>
  );
}
